import React from "react";
import { Card, CardBody, Col, Row } from "reactstrap";

// Remove the RadialChart imports since we won't be using them anymore
// import RadialChart1 from "./userpanelChart1";
// import RadialChart2 from "./userpanelChart2";
// import RadialChart3 from "./userpanelChart3";

const UserPanel2 = ({ partsData ,selectedChildPart}) => {
  // Keep the calculations for potential future use
  const per_total_running_hour = partsData.total_running_hours > 0 ? (partsData.total_running_hours / 8) * 100 : 0;
  const per_total_running_hour_ago =
    (partsData.total_running_hours_ago / 8) * 100;
  const diff_total_running_hour =
    per_total_running_hour - per_total_running_hour_ago;


   const part_multiple =selectedChildPart;
  
  // Fix bad parts percentage calculation
  let per_bad_parts = 0;
  if (partsData.total_parts !== 0) {
    per_bad_parts = (partsData.bad_parts / partsData.total_parts) * 100;
  } else {
    per_bad_parts = 0;
  }
  
  // Ensure good parts percentage is calculated correctly
  let per_good_parts = 0;
  if (partsData.total_parts !== 0) {
    per_good_parts = (partsData.good_parts / partsData.total_parts) * 100;
  } else {
    per_good_parts = 0;
  }

  let per_good_parts_ago = 0;
  if (partsData.total_parts_ago !== 0) {
    per_good_parts_ago =
      (partsData.good_parts_ago / partsData.total_parts_ago) * 100;
    per_good_parts_ago = per_good_parts_ago - per_bad_parts;
  } else {
    per_good_parts_ago = 0;
  }

  let per_bad_parts_ago = 0;
  if (partsData.total_parts_ago !== 0) {
    per_bad_parts_ago =
      (partsData.bad_parts_ago / partsData.total_parts_ago) * 100;
    per_bad_parts_ago = per_bad_parts_ago - per_bad_parts;
  } else {
    per_bad_parts_ago = 0;
  }

  let per_total_parts_ago = 0;
  if (partsData.total_parts !== 0) {
    per_total_parts_ago =
      (partsData.total_parts_ago -
        partsData.total_parts / partsData.total_parts) *
      100;
  } else {
    per_total_parts_ago = 0;
  }

  // console.log(per_bad_parts, per_good_parts, per_bad_parts_ago, per_good_parts_ago, per_total_parts_ago, per_total_running_hour, per_total_running_hour_ago)
  return (
    <React.Fragment>
      <Row>
        <Col xl={3} sm={6}>
          <Card>
            <CardBody>
              <div className="d-flex text-muted">
                <div className="flex-shrink-0 me-3 align-self-center">
                  {/* Replace RadialChart with icon */}
                  <div className="avatar-sm">
                    <div className="avatar-title bg-light rounded-circle text-primary" style={{ fontSize: '24px', width: '40px', height: '40px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                      <i className="ri-time-line"></i>
                    </div>
                  </div>
                </div>

                <div className="flex-grow-1 overflow-hidden">
                  <p className="mb-1">Running hours</p>
                  <h5 className="mb-3">{partsData.total_running_hours}</h5>
                  {/* Commented section remains the same */}
                </div>
              </div>
            </CardBody>
          </Card>
        </Col>

        <Col xl={3} sm={6}>
          <Card>
            <CardBody>
              <div className="d-flex">
                <div className="flex-shrink-0 me-3 align-self-center">
                  {/* Replace RadialChart with icon */}
                  <div className="avatar-sm">
                    <div className="avatar-title bg-light rounded-circle text-success" style={{ fontSize: '24px', width: '40px', height: '40px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                      <i className="ri-checkbox-circle-line"></i>
                    </div>
                  </div>
                </div>

                <div className="flex-grow-1 overflow-hidden">
                  <p className="mb-1">Good Parts</p>
                  <h5 className="mb-3">{partsData.good_parts*part_multiple||0}</h5>
                  {/* Commented section remains the same */}
                </div>
              </div>
            </CardBody>
          </Card>
        </Col>

        <Col xl={3} sm={6}>
          <Card>
            <CardBody>
              <div className="d-flex text-muted">
                <div className="flex-shrink-0 me-3 align-self-center">
                  {/* Replace RadialChart with icon */}
                  <div className="avatar-sm">
                    <div className="avatar-title bg-light rounded-circle text-danger" style={{ fontSize: '24px', width: '40px', height: '40px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                      <i className="ri-close-circle-line"></i>
                    </div>
                  </div>
                </div>

                <div className="flex-grow-1 overflow-hidden">
                  <p className="mb-1">Bad Parts</p>
                  <h5 className="mb-3">{partsData.bad_parts*part_multiple||0}</h5>
                  {/* Commented section remains the same */}
                </div>
              </div>
            </CardBody>
          </Card>
        </Col>

        <Col xl={3} sm={6}>
          <Card>
            <CardBody>
              <div className="d-flex text-muted">
                <div className="flex-shrink-0 me-3 align-self-center">
                  <div className="avatar-sm">
                    <div className="avatar-title bg-light rounded-circle text-primary" style={{ fontSize: '24px', width: '40px', height: '40px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                      <i className="ri-group-line"></i>
                    </div>
                  </div>
                </div>
                <div className="flex-grow-1 overflow-hidden">
                  <p className="mb-1">Total Parts</p>
                  <h5 className="mb-3">{partsData.total_parts*part_multiple||0}</h5>
                  {/* Commented section remains the same */}
                </div>
              </div>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </React.Fragment>
  );
};

export default UserPanel2;
